module.exports = __webpack_public_path__ + "img/V89.4c2744f1.jpg";